import React from "react";
import { Link } from "react-router-dom";
import { AlertCircle, ArrowRight, HeartHandshake } from "lucide-react";

const NON_FACCIO = [
  "Non svolgo psicoterapia (che richiede una specializzazione post-lauream diversa dalla mia).",
  "Non effettuo diagnosi neuropsicologiche né valutazioni diagnostiche.",
  "Non mi occupo di neurodivergenze come area clinica specialistica (v. paragrafo sotto).",
  "Non svolgo trattamenti specialistici focalizzati sul trauma complesso o sul PTSD.",
  "Non tratto i disturbi alimentari come area specialistica.",
  "Non mi occupo di dipendenze come area specifica.",
  "Non seguo persone minorenni.",
];

export default function QuandoNonSonoGiusta() {
  return (
    <div className="container-editorial py-16 lg:py-24" data-testid="page-quando-non-sono-giusta">
      <div className="max-w-3xl">
        <span className="pill">Trasparenza · Nota clinica</span>
        <h1 className="mt-4 font-display text-5xl sm:text-6xl tracking-tighter leading-[0.95] dark:text-cream">Quando potrei non essere la persona giusta.</h1>
        <p className="mt-6 text-lg text-viola/80 dark:text-cream/80 leading-relaxed">
          Preferisco dire chiaramente cosa non faccio. Ogni professionistə ha ambiti specifici di competenza: riconoscerli è parte della cura.
        </p>
      </div>

      <div className="mt-12 max-w-3xl rounded-2xl bg-lilla dark:bg-viola/30 border border-viola/10 dark:border-cream/10 p-8" data-testid="non-faccio-list">
        <ul className="space-y-4 text-viola/85 dark:text-cream/85">
          {NON_FACCIO.map((t) => (
            <li key={t.slice(0, 40)} className="flex gap-4 items-start">
              <AlertCircle className="text-fucsia mt-1 shrink-0" size={20} />
              <span className="leading-relaxed">{t}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-12 max-w-3xl space-y-8 text-viola/85 dark:text-cream/85 leading-relaxed">
        <div>
          <h2 className="font-display text-2xl sm:text-3xl dark:text-cream">Neurodivergenze — con cui lavoro, ma non come specializzazione</h2>
          <p className="mt-4">
            Lo studio è <strong>neurodivergent-friendly</strong>: ho esperienza nel lavoro con persone neurodivergenti già diagnosticate e pongo particolare attenzione all'accessibilità della comunicazione e del percorso. <strong>Non mi occupo invece di valutazione diagnostica o percorsi specialistici sulle neurodivergenze.</strong>
          </p>
        </div>

        <div>
          <h2 className="font-display text-2xl sm:text-3xl dark:text-cream">Trauma — trauma-informed, non trauma-specialist</h2>
          <p className="mt-4">
            Il mio lavoro è <strong>trauma-informed</strong>: riconosco l'impatto che le esperienze traumatiche possono avere sul benessere psicologico e tengo conto di questi aspetti nel percorso. <strong>Non svolgo tuttavia trattamenti specialistici focalizzati sul trauma complesso o sul PTSD.</strong>
          </p>
        </div>
      </div>

      <div className="mt-16 max-w-3xl rounded-2xl bg-viola text-cream p-10" data-testid="orient-cta">
        <div className="grid md:grid-cols-[auto_1fr] gap-6 items-start">
          <div className="grid h-14 w-14 place-items-center rounded-full bg-giallo text-viola shrink-0"><HeartHandshake size={24} /></div>
          <div>
            <h2 className="font-display text-3xl">Se non sono la persona giusta, ti aiuto a trovarla.</h2>
            <p className="mt-4 text-cream/85 leading-relaxed">
              Se durante i primi incontri dovesse emergere che un'altra persona professionista è più indicata per quello che stai cercando, ne parleremo insieme e, quando possibile, ti orienterò verso un <strong>invio mirato</strong>.
            </p>
            <p className="mt-4 text-cream/85 leading-relaxed">
              Puoi anche esplorare la <Link to="/rete" className="text-giallo font-semibold underline underline-offset-2">Rete GSRD</Link> — una directory di professionistə della salute mentale con approccio affermativo, sex-positive e attentə alla pluralità delle esperienze.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/rete" className="btn-secondary" data-testid="orient-rete">Vai alla Rete GSRD</Link>
              <Link to="/contatti" className="inline-flex items-center gap-2 text-cream font-semibold hover:gap-3 transition-all">Contattami <ArrowRight size={16} /></Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
